import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import BackgroundImg from "gatsby-background-image"
import gradient from "../homepage.module.css"

const BackgroundImage = ({ children }) => {
  const data = useStaticQuery(graphql`
    query {
      desktop: file(relativePath: { eq: "hero.jpg" }) {
        childImageSharp {
          fixed(quality: 90, width: 1920) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return (
    <BackgroundImg
      Tag="section"
      fluid={data.desktop.childImageSharp.fixed}
      backgroundColor={`#2D58EC`}
    >
      <div id={gradient.heroImageGradient}>{children}</div>
    </BackgroundImg>
  )
}

export default BackgroundImage
